import React, { Fragment } from 'react'
import PropTypes from 'prop-types'
import styled, { css } from 'styled-components'
import shuffle from 'helpers/shuffle'
import Checkbox from 'components/common/FormElements/Checkbox/Checkbox'
import Theme from 'components/common/Theme/Theme'
import Media from 'components/common/Media'
import Columns from 'components/common/Columns/Columns'
import { setRequiredAttrs } from '../helpers'

const CheckboxList = ({
  dataAttributes,
  value,
  ResetControl,
  defaultData = [],
  handleChange,
  handleReset,
  inline,
  name,
  onKeyDown,
  required,
  servicesDrawer,
  inputColor = ''
}) =>
  <Fragment>
    {ResetControl &&
      <ResetControl name={ name } active={ value.length === 0 } onReset={ handleReset } />
    }
    {
      servicesDrawer ?
        <StyledColumns adaptive width="50% 50%">
          {
            shuffle.halfs(defaultData).map((defaultDataSplit, index) =>
              <Fragment key={ index }>
                {
                  defaultDataSplit.map(({ label, value: checkboxValue, name, revenue }, index) =>
                    <Flag
                      dataAttributes={ dataAttributes }
                      inline={ inline }
                      servicesDrawer={ servicesDrawer }
                      key={ index }
                      placeholder={ index }
                      inputColor={ inputColor }
                      name={ name }
                      label={ label }
                      value={ value && value.includes(checkboxValue) }
                      { ...setRequiredAttrs(required) }
                      onChange={ e => handleChange(checkboxValue, e.target.checked, revenue, label) }
                      onKeyDown={ onKeyDown } />
                  )
                }
              </Fragment>
            )
          }
        </StyledColumns> :
        defaultData
          .map(({ label, value: checkboxValue, name, revenue }, index) =>
            <Flag
              dataAttributes={ dataAttributes }
              inline={ inline }
              key={ index }
              placeholder={ index }
              inputColor={ inputColor }
              name={ name }
              label={ label }
              value={ value && value.includes(checkboxValue) }
              { ...setRequiredAttrs(required) }
              onChange={ e => handleChange(checkboxValue, e.target.checked, revenue, label) }
              onKeyDown={ onKeyDown } />
          )
    }
  </Fragment>

CheckboxList.propTypes = {
  dataAttributes: PropTypes.shape(),
  defaultData: PropTypes.arrayOf(PropTypes.shape()),
  handleChange: PropTypes.func,
  handleReset: PropTypes.func,
  inline: PropTypes.bool,
  inputColor: PropTypes.string,
  name: PropTypes.string,
  onKeyDown: PropTypes.func,
  required: PropTypes.bool,
  ResetControl: PropTypes.func,
  servicesDrawer: PropTypes.bool,
  value: PropTypes.node
}

export default CheckboxList

const Flag = styled(Checkbox)`
  :last-child {
    margin-bottom: 0;
  }

  ${props => props.inline && css`
    margin-bottom: 17px;
    color: ${Theme.colors.black};
    ${Media.desktop`
      display: inline-block;
      width: 33.3333%;

      :last-child,
      :nth-last-child(2),
      :nth-last-child(3) {
        margin-bottom: 0;
      }
    `}
  `}
  ${props => props.servicesDrawer && css`
    && {
      display: block;
      margin-bottom: 10px;
    }

    & [data-checkbox-text] {
      white-space: nowrap;
    }
  `}
`

const StyledColumns = styled(Columns)`
  & [data-column] {
    padding: 0 10px;
  }
`
